<template>
<div>
  <div>
    <el-button @click="view(mainObj.id)">巡检任务</el-button>
    <el-button v-if="qrcode" @click="showQrcode()">巡检二维码</el-button>
  </div>
  <div class="form-page-title-info">巡检记录</div>
  <el-table height="50vh" v-loading="loading" :data="pageData.list" border style="width: 100%">
    <el-table-column prop="id" label="ID" width="80"></el-table-column>
    <el-table-column prop="project_name" label="项目" width="160"></el-table-column>
    <el-table-column prop="address_name" label="蓝牙/巡检点"></el-table-column>
    <el-table-column prop="department_name" label="部门" width="200"></el-table-column>
    <el-table-column prop="status_name" label="类型" width="100"></el-table-column>
    <el-table-column prop="user_name" label="检查人" width="100"></el-table-column>
    <el-table-column prop="status_name" label="状态" width="110"></el-table-column>
    <el-table-column prop="e_date_formatted" label="提交时间" width="160"></el-table-column>
    <el-table-column prop="result_name" label="结果" width="100"></el-table-column>
  </el-table>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>

  <Modal v-model="modal3" ok-text="关闭" top="10vh" width="80%" title="巡检任务" :loading="loadingModal">
    <div>
      <template>
        <el-button @click="addtask(mainObj.id)">添加任务</el-button>
        <div class="form-page-title-info">任务列表</div>
        <el-table :data="pageDataB.list" border style="width: 100%" v-loading="loadingB">
          <el-table-column label="主要部门" prop="department_name"></el-table-column>
          <el-table-column label="类型" prop="frequency_type">
            <template slot-scope="sped">
              <span v-if="sped.row.frequency_type==1">日</span>
              <span v-if="sped.row.frequency_type==2">周</span>
              <span v-if="sped.row.frequency_type==3">月</span>
              <span v-if="sped.row.frequency_type==4">季</span>
              <span v-if="sped.row.frequency_type==5">半年</span>
              <span v-if="sped.row.frequency_type==6">年</span>
            </template>
          </el-table-column>
          <el-table-column label="频次" prop="frequency_number"></el-table-column>
          <el-table-column label="状态" prop="status">
            <template slot-scope="sped">
              <span v-if="sped.row.status==1">开启</span>
              <span v-if="sped.row.status==2" style="color: red;">关闭</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <Modal v-model="modal4" ok-text="关闭" top="10vh" width="550px" title="巡检任务">
      <el-form>
        <el-form-item label="主要部门">
          <el-select size="mini" v-model="form.department_id" placeholder="主要部门">
            <el-option
              v-for="item in departmentList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检类型">
          <el-radio-group v-model="form.frequency_type">
              <el-radio :label="1">日</el-radio>
              <el-radio :label="2">周</el-radio>
              <el-radio :label="3">月</el-radio>
              <el-radio :label="4">季</el-radio>
              <el-radio :label="5">半年</el-radio>
              <el-radio :label="6">年</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="巡检次数">
            <el-select size="mini" v-model="form.frequency_num" placeholder="巡检次数" >
              <el-option
                v-for="item in frequencyNum"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <div class="button-box">
          <el-button @click="modal4 = false">取消</el-button>
          <el-button type="primary" @click="onSave()">保存</el-button>
        </div>
      </el-form>
    </Modal>
  </Modal>
  <Modal v-model="visable" title="巡检二维码" width="300px" top="10vh" ok-text="关闭">
  	<div style="text-align: center;">
  	    <img :src="qrcode" alt="巡检二维码" style="width: 280px;"/>
  	</div>
  </Modal>
</div>

</template>

<script>
export default {
  name: "PaymentFees",
  inject:['mainObj'],
  data(){
    return{
      qrcode: '',
      visable: false,
      ProcessState:0,
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 10,
        page: 1,
      },
      loadingB:false,
      pageDataB: {
        list: [],
        total: 0,
        pageSize: 100,
        page: 1,
      },
      departmentList: [],
      frequency_type: [],
      frequencyNum: [
        {id:1,value:'1次'},
        {id:2,value:'2次'},
        {id:3,value:'3次'},
        {id:4,value:'4次'},
        {id:5,value:'5次'},
        {id:6,value:'6次'},
        {id:7,value:'7次'},
        {id:8,value:'8次'},
        {id:9,value:'9次'},
        {id:10,value:'10次'},
      ],
      modal3: false,
      loadingModal: false,
      taskList: [],
      modal4: false,
      detail: {},
      form: {
        department_id: '',
        frequency_index: 1,
        frequency_type: 1,
        frequency_num: 1,
      },
      from_department_id: ''
    }
  },
  mounted() {
    this.getData()
    this.getList()
    this.gettaskList()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.detail=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
      pageChange(i) {
        this.pageData.page = i
        this.getList()
      },
      getList() {
        const that = this;
        that.loading = true;
        ERP.postRequest({
          url: "admin/HouseFurnish/getLog",
          data: {
            page: that.pageData.page,
            pageSize: that.pageData.pageSize,
            fitment_id: that.mainObj.id
          }
        }, res => {
          if(res.code == 0) {
            that.pageData.list = res.data.list
            that.pageData.total = res.data.total
          }
          that.loading = false;
        })
      },
      view(id) {
        this.modal3 = true;
        this.loadingModal = true;
        const that = this;
        ERP.postRequest({
          url: "admin/HouseFurnish/getPdaInfo",
          data: {}
        }, res => {
            that.departmentList = res.data.department
        })
        this.gettaskList()
      },
      gettaskList(){
        const that = this;
        that.loadingB = true;
        ERP.postRequest({
          url: "admin/HouseFurnish/getTask",
          data: {
            page: that.pageDataB.page,
            pageSize: that.pageDataB.pageSize,
            fitment_id: that.mainObj.id
          }
        }, res => {
          if(res.code == 0) {
            that.pageDataB.list = res.data.list
            that.qrcode = res.data.qrcode
          }
          that.loadingB = false;
        })
      },
      showQrcode() {
        this.visable = true
      },
      addtask(id) {
        this.modal4 = true;
        this.form.department_id = ''
        this.form.frequency_type = 1
        this.form.frequency_num = 1
      },
      onSave() {
        const that = this;
        const postData = {
          department_id: that.form.department_id,
          frequency_type: that.form.frequency_type,
          frequency_num: that.form.frequency_num,
          house_id: that.detail.HouseID,
          house_name: that.detail.house_name,
          renovation_id: that.detail.ID,
        }
        ERP.postRequest({
          url: "admin/HouseFurnish/savePda",
          data: postData
        }, res => {
          if(res.code==0){
            that.$msgbox.alert(res.msg)
            this.modal4 = false;
            this.gettaskList()
          }else{
            that.$msgbox.alert(res.msg||"查询失败")
          }
        })
      }
  }
}
</script>

<style scoped>
.form-page-title-info{
	  width:100%;
	  padding: 4px 0px;
	  font-weight: 700;
	  line-height: 36px;
	  background-color: #f7f8fa;
	  border-bottom: 1px solid #e5e5e5;
    margin-top: 5px;
	}
  .pagination-wrap{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/pda_check/PdaInspection.vue